import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"
import Marquee from "react-fast-marquee"

export const meta: BlockMeta = {
  title: "Logo Carousel",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/logo-carousel", (props) => {
  return (
    <ScrollReveal className="w-full flex flex-col gap-7 my-10">
      <div
        className={cn(
          "w-grid mx-auto flex flex-col gap-4",
          props.centredTitle && "items-center justify-center text-center",
        )}
        data-transition="fade"
      >
        <EditableText as="p" store="title" className="type-label-xl" placeholder="Enter a title" />
        <EditableText as="p" store="subtitle" className="type-label-l" placeholder="Enter an optional subtitle" />
      </div>
      <div className="w-full overflow-hidden">
        {env.client && (
          <Marquee speed={50} autoFill className="flex items-center">
            {env.admin && (!props.logos || props.logos.length === 0) && (
              <div className="w-logoCarouselItemW aspect-[1/0.83] flex items-center justify-center bg-grey rounded-lg border-2 border-black ml-5">
                <p className="type-label-m">Add a logo</p>
              </div>
            )}
            {props.logos?.map((logo, index) => {
              const El = logo?.link?.url ? Link : "div"
              const elProps = logo?.link?.url
                ? {
                    href: logo.link.url,
                    target: logo.link.target || "_self",
                  }
                : {}

              return (
                logo?.logo?.mediaItemUrl && (
                  <El
                    key={index}
                    {...elProps}
                    className={cn(
                      "w-logoCarouselItemW aspect-[1/0.83] flex items-center justify-center border-current border-2 rounded-lg ml-5",
                    )}
                    data-transition="scale"
                  >
                    <img src={logo?.logo?.mediaItemUrl} alt="Logo" className="block w-[70%] h-auto" />
                  </El>
                )
              )
            })}
          </Marquee>
        )}
      </div>
    </ScrollReveal>
  )
})
